export const order = [
    'xxx-small',
    'xx-small',
    'x-small',
    'small',
    'medium',
    'large',
    'x-large',
    'xx-large',
    'xxx-large',
];

export const defaultSize = 'default';
export const splitDelimiter = '--';

export function reduceIcons(iconList, icon) {
    let [size, name] = icon.id.split(splitDelimiter);

    if (!name) {
        name = size;
        size = defaultSize;
    }

    const viewbox = icon.getAttribute('viewBox').split(' ');
    const dimensions = `${ viewbox[2] } × ${ viewbox[3] }`;

    // NOTE: `iconList[size]` and `sizeList[dimension]` are repeated to assign a value for later access:
    const sizeList = iconList[size] = iconList[size] || {};
    const dimensionsList = sizeList[dimensions] = sizeList[dimensions] || [];

    dimensionsList.push({
        id: icon.id,
        name: name,
        w: viewbox[2],
        h: viewbox[3],
    });

    return iconList;
}

export function sortByOrder(a, b) {
    const [first] = a.id.split(splitDelimiter);
    const [second] = b.id.split(splitDelimiter);

    const indexInOrder = [].indexOf.bind(order);

    if (indexInOrder(first) > indexInOrder(second)) {
        return 1;
    }

    if (indexInOrder(first) < indexInOrder(second)) {
        return -1;
    }

    return 0;
}

export function sortIconsByName(icons) {
    return icons.slice().sort(function(entryA, entryB) {
        const a = entryA.name.toLowerCase();
        const b = entryB.name.toLowerCase();

        if (a < b) {
            return -1;
        }
        if (a > b) {
            return 1;
        }
        return 0;
    });
}

export function iconSize(size, icon) {
    return (size === 'default') ? { width: `${ icon.w }px`, height: `${ icon.h }px` } : {};
}

export function querySymbols(selector) {
    const symbols = document.querySelectorAll(selector);

    // Sort the icons by the right order
    const icons = Array.from(symbols).sort(sortByOrder);

    return icons.reduce(reduceIcons, {});
}

export function getIcons() {
    const DonePromise = new Promise(resolve => {
        if (globals.state.svgSymbolsLoaded) {
            resolve();
        } else {
            window.addEventListener('icons-loaded', resolve);
        }
    });

    return DonePromise
        .then(() => querySymbols('.u-icon-sprite symbol'))
        .catch(error => console.error(error));
};


